export default __webpack_public_path__ + "static/media/nl-bg-2.d15cfc0c.webp";